<template>
    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
        <b-card class="mt-2 mx-0 border-none p-0">
            <div class="animated fadeIn">
                <b-row no-gutters>
                    <b-col class="pr-2" sm="6" md="6" xl="4" v-for="(bank, index) in bankings" :key="index">

                        <b-card no-body class="onhover p-0">

                            <!-- @click="$router.push('/bankings') -->

                            <b-card-header class="pointer"
                                @click="$store.commit('set', ['selection', [{ id: bank.id }]]); $router.push('/bankingsedit?showheader=true');">
                                <div :class="accountclass(bank)">
                                    <span>{{ acccountlabel(bank) }}</span>
                                </div>
                                <b-row align-v="center">
                                    <b-col>
                                        <div class="mb-2">
                                            <h4 class="strong uppercase text-1vw"> {{ bank.accountname }}</h4>
                                            <h6>{{ bank.sortno }}-{{ bank.accountno }}</h6>
                                        </div>
                                    </b-col>
                                    <b-col cols="3">
                                        <div class="float-right small text-right mr-3"
                                            style="height:60px; display:flex; justify-content: center;">
                                            <img class="logo w-60px" style="margin:auto; display:block; "
                                                :src="bank.banklogo" :alt="bank.bankname" :title="bank.bankname" />

                                        </div>

                                    </b-col>
                                    <!-- <b-col cols="1" class="mr-3 z-0">
                                        <b-dropdown class="float-right z-1" variant="transparent p-0" right no-caret>
                                            <template slot="button-content">
                                                <i class="fa fa-ellipsis-v"></i>
                                            </template>
<b-dropdown-item>{{ bank.accountname }}</b-dropdown-item>
<b-dropdown-item>Import statement...</b-dropdown-item>

</b-dropdown>
</b-col> -->
                                </b-row>
                            </b-card-header>

                            <b-card-body class="p-0">
                                <b-row class="ml-0 p-1" align-v="center" no-gutters
                                    @click="$store.commit('set', ['selection', [{ id: bank.id }]]); $router.push('/bankingsedit?showheader=true');">
                                    <b-col cols="12" sm="4">

                                        <b-button class="ml-3" v-if="parseFloat(bank.unmatched) > 0" size="sm"
                                            variant="dark"
                                            @click.native="$store.commit('set', ['selection', [{ id: bank.id }]]); $router.push('/bankingsedit?showheader=true');"
                                            :to="'/bankingsedit'">
                                            <span class="text-06vw"><span class="display-xl">{{ unmatched_label(bank) }}</span> {{
                                                bank.unmatched }}
                                                items...</span></b-button>

                                        <div v-if="parseFloat(bank.unmatched) == 0">
                                            <b-row align-v="center" no-gutters>
                                                <b-col cols="auto">
                                                    <i class="fa fa-check-circle fa-2x text-primary pl-3 pr-2"></i>
                                                </b-col>
                                                <b-col> <span class="text-085vw">Matched</span></b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" sm="8" class="text-08vw">
                                        <b-row no-gutters v-if="parseFloat(bank.unmatched) > 0">
                                            <b-col cols="12" lg="8" class="text-right nowrap"><span>Balance in
                                                    BOP:</span></b-col>
                                            <b-col cols="12" lg="4">
                                                <b-row align-h="between" no-gutters>
                                                    <b-col class="text-right">
                                                        {{ bank.balance | currency("") }}
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters>
                                            <b-col cols="12" lg="8" class="text-right nowrap">
                                                <span>Statement ( {{
                                                    $moment.unix(bank.balance_at * .001).format("DD MMM YY") }}
                                                    ):</span>
                                            </b-col>
                                            <b-col cols="12" lg="4">
                                                <b-row align-h="between" no-gutters>
                                                    <b-col class="text-right">
                                                        {{ bank.balance | currency("") }}
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="p-2">
                                    <b-col>
                                        <component id="bank-chart-header" v-if="!timeout" :is="'LineChart'"
                                            :data="bank.chart" :chartId="chartId" style="height:200px;" :height="200">
                                        </component>
                                    </b-col>
                                </b-row>

                            </b-card-body>

                        </b-card>
                    </b-col>

                </b-row>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";

import LineChart from "@/pages/private/charts/Line-chart";
import shortid from "shortid";

//import bankBSP from "../Apps/Accounts/BankAccounts/BSPRecords.vue";
//import bankConferma from "../Apps/Accounts/BankAccounts/ConfermaCard";

export default {
    name: "BankingCards",
    props: ["tile", "refresh"],
    components: {
        LineChart,
        //bankBSP,
        //bankConferma
    },
    data() {
        return {
            busy: false,
            timeout: false,
            chartId: shortid.generate(),
            name: "Accounts",
            bankings: [],
        }
    },
    async mounted() {
        // await this.loadChart();
    },
    watch: {
        refresh: {
            immediate: true,
            async handler(newVal, oldVal) {
                await this.loadChart();
            },
        },
        tile: {
            immediate: true,
            async handler(newVal, oldVal) {
                // await this.loadChart();
            },
        },
    },
    computed: {
        chartType() {
            if (!this.tile.settings) {
                return "Line";
            }
            if (this.tile.settings) {
                let setting = this.tile.settings.find((o) => o.key == "type");
                return setting.value;
            } else {
                return "Line";
            }
        }
    },
    methods: {
        accountclass(account) {
            if (account.type == 'credit') {
                return 'highlight-triangle success'
            } else {
                return 'highlight-triangle danger'

            }
        },
        acccountlabel(account) {
            if (account.type == 'credit') {
                return 'Credit'
            } else {
                return 'Debit'
            }
        },
        unmatched_label(account) {
            if (account.accountno.includes('LLOYDS') ) {
                return 'Unposted'
            } else if (account.accountno.includes('BSP')) {
                return 'Blackhole'
            } else {
                return 'Inventory'
            }
        },
        async loadChart() {

            this.busy = true
            this.accounts = [];

            let variables = {
                limit: 10,
                isdashboard: true,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankings(
                            $limit: Int            
                            $isdashboard: Boolean
                            ) {
                            bankings(
                                limit: $limit
                                isdashboard: $isdashboard
                            ) {
                                id
                                type
                                sortno
                                accountno
                                accountname                    
                                bankname   
                                banklogo
                                currency
                                balance   
                                balance_at                           
                                isactive   
                                isdashboard
                                unmatched
                                chart {
                                    labels
                                    datasets {
                                        label
                                        data
                                        backgroundColor
                                        borderColor
                                    }  
                                }
                        }
                    }
                `,
                    variables,
                });

                this.bankings = response.data.bankings

            } catch (error) {
                console.log(error);
            }
            this.busy = false
            await this.$emit("refreshed");
        },
    }
}
</script>